module.exports = __webpack_public_path__ + "img/whatsapp.73915d28.svg";